import { nonceStr, timestamp, decrypt } from "@/utils/util";
import http from "@/utils/http";
import { loadEnv } from "@build/index";
import {
  UpFileReq,
  UpFileRes,
  dsFileReq,
  dsFileRes,
  AppReadRes,
  HomePageRateRes
} from "/#/JHT";
import { PureHttpRequestConfig } from "@/utils/http/types";
const { VITE_RANDOM } = loadEnv();

// 获取ticket
export async function getTicket() {
  const data = {
    nonceStr: nonceStr(),
    timestamp: timestamp
  };
  const res = await http.post("/v2/ticket/getTicket", data);
  return JSON.parse(decrypt(res.result as string, VITE_RANDOM));
}

// 项目初始
export async function homePage(data: object) {
  const res: AppReadRes = await http.post("/plat/merchant/homePage", data);
  return res;
}
// 获取汇率
export async function homePageRate(
  data: object,
  config?: PureHttpRequestConfig
) {
  const res: HomePageRateRes = await http.post(
    "/plat/merchant/homePageRate",
    data,
    config
  );
  return res;
}

// 获取注册短信验证码
// export async function getRegCode(data) {
//   const res = await http.post("/captcha/getByRegister", data);
//   return res;
// }

// 上传文件
export async function upPic(data: UpFileReq, config?: PureHttpRequestConfig) {
  const res: UpFileRes = await http.post(
    "/plat/encloseure/enclosureUpload",
    data,
    config
  );
  return res;
}

// 下载文件
export async function dsFile(data: dsFileReq, config?: PureHttpRequestConfig) {
  const res: dsFileRes = await http.post(
    "/plat/encloseure/enclosureBaseDownLoad",
    data,
    config
  );
  return res;
}
